import {IAudioConfig, ISoundConfig} from '@gongxigames/framework/slot/types';

/**
 * Use /soundType/ in order to insert text in source of soundManager or music
 */
const soundConfig: ISoundConfig = {
    defaultPriority: {
        buttonclick: 'basic_uitbuttonclick',
        buttontoggle: 'basic_uitogglebutton',
        spinclick: 'basic_spinclick',
        betbuttondown: 'basic_betbuttondown',
        betbuttonup: 'basic_betbuttonup',
        betbuttonmax: 'basic_betbuttonmaxbet',

        reelstop1: 'basic_reelstop1',
        reelstop2: 'basic_reelstop2',
        reelstop3: 'basic_reelstop3',
        reelstop4: 'basic_reelstop4',
        reelstop5: 'basic_reelstop5',
        reelstop6: 'basic_reelstop6',
        scatterhit1: 'basic_scatterhit1',
        scatterhit2: 'basic_scatterhit2',
        scatterhit3: 'basic_scatterhit3',
        scatterhit4: 'basic_scatterhit4',
        scatterhit5: 'basic_scatterhit5',
        scatterhit6: 'basic_scatterhit6',

        quickstop2scatter: 'basic_quickstop2scatter',
        quickstop3ormorescatter: 'basic_quickstop3ormorescatter',

        winSingle: 'gxg_/soundType/_win_single',
        win1a: 'gxg_/soundType/_win1a',
        win1b: 'gxg_/soundType/_win1b',
        win2a: 'gxg_/soundType/_win2',
        win2b: 'gxg_/soundType/_win2b',
        win3a: 'gxg_/soundType/_win3',
        win3b: 'gxg_/soundType/_win3b',
        win4a: 'gxg_/soundType/_win4',
        win4b: 'gxg_/soundType/_win4b',
        win5: 'gxg_/soundType/_win5',
        win6: 'gxg_/soundType/_win6',
        hyperspin: 'basic_hyperspin',
        ...GAME_PROVIDER_SOUND_CONFIG.defaultPriority
    },
    afterPriority: {
        bannertransitionenter: 'basic_bannertransitionenter',
        bannertransitionexit: 'basic_bannertransitionexit',
        freespintrigger: 'basic_freespintrigger',
        premonition: 'basic_premonition',
        bigwin: 'gxg_/soundType/_bigwin',
        bigwinend: 'gxg_/soundType/_bigwin_end',
        ...GAME_PROVIDER_SOUND_CONFIG.afterPriority
    }
};

const musicConfig: ISoundConfig = {
    defaultPriority: {
        maingame: 'basic_maingameloop'
    },
    afterPriority: {
        freespin: 'basic_freegameloop',
        maingame2: 'basic_maingameloop2'
    }
};

export const audioConfig: IAudioConfig = {
    soundConfig,
    musicConfig,
    soundType: 'asian',
    properties: {
        freegametrigger: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        win4a: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        win4b: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        win5: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        win6: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        bigwin: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        freespintrigger: {
            panning: 0,
            duck: {volume: 0.1, fadeDuration: 300}
        },
        maingame2: {
            loop: false
        }
    }
};
